import React from "react";
import { Link } from "react-router-dom";
import "../../common/bg.css";
import "./c.css";
import WebsiteName from "../../common/WebsiteName/WebsiteName";
import Navbar from "../../common/Navbar/NavBar";
import Location from "../../common/Location/Location";
import Footer from "../../common/Footer/Footer";
export default function PHP() {
  return (
    <>
      <section className="bgImageCommon">
        <WebsiteName />
        <Navbar />
        <Location title="PHP" />
        <section>
          <div className="cBody">
            <div id="cardDIV">
              <h1 className="text-dark" id="laguage_Title">
                PHP
              </h1>
              <p className="text-secondary" id="Language_Para">
                PHP is an open-source server-side scripting language that
                numerous developers rely on to operate several projects,
                including Graphical User Interfaces (GUIs). The abbreviation
                PHP, formerly for Personal Homepage, now refers to Hypertext
                Preprocessor. It is a favored programming language primarily for
                creating and building websites and web applications with MySQL.
                It is a developer-friendly programming language equipped with
                several open sources and integrated development environments.
                <br />
                The PHP programming language also is filled with several
                benefits that aid you in creating outstanding results. It is
                open-source and feature-rich, and its features and functionality
                are at par with several other paid scripting languages. It also
                has a relatively simple installation and setup process. There
                are several other benefits in learning his language that
                numerous developers use; let's find out all the advantages it
                offers.
              </p>
              <Link
                name=""
                id=""
                class="btn btn-danger"
                to="/Courses"
                role="button">
                {"<< "}back
              </Link>
            </div>
          </div>
        </section>
        <Footer />
      </section>
    </>
  );
}
